const WidgetWaitInterval = 250;
const WidgetWaitAttempts = 240;

export const visibilityCommand = (isHidden) => (isHidden ? 'hide' : 'minimize');

export const restoreCommand = (isHidden, wasMaximized) =>
  !isHidden && wasMaximized ? 'maximize' : visibilityCommand(isHidden);

const widgetApi = () => window.LiveChatWidget;

export const whenWidgetReady = (run) => {
  if (widgetApi()) {
    run();
    return () => {};
  }

  let attemptsLeft = WidgetWaitAttempts;

  const timer = setInterval(() => {
    attemptsLeft -= 1;

    if (widgetApi()) {
      clearInterval(timer);
      run();
    } else if (attemptsLeft <= 0) {
      clearInterval(timer);
    }
  }, WidgetWaitInterval);

  return () => clearInterval(timer);
};

export const callWidget = (command) => widgetApi()?.call(command);

export const isWidgetMaximized = () => {
  try {
    return widgetApi()?.get('state')?.visibility === 'maximized';
  } catch {
    return false;
  }
};

export const callWidgetWhenReady = (command) => whenWidgetReady(() => callWidget(command));
